class CustomiseProductMenu extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button')
    this.container = this.querySelector('.product-custom-print-container')
    this.dropDownMenu = this.querySelector('.product-custom-print-dropdown-btn')    
    this.dropDownMenuOptions = this.querySelector('.product-custom-print-options')
    
    this.button.addEventListener('click', this.buttonClicked.bind(this))
    this.dropDownMenu.addEventListener('click', this.dropDownMenuClicked.bind(this))
  }

  buttonClicked() {
    const opened = this.button.getAttribute('aria-expanded') === "true"
    this.button.setAttribute('aria-expanded', !opened)
    this.container.setAttribute('aria-hidden', opened)
  }

  dropDownMenuClicked() {
    const opened = this.dropDownMenu.getAttribute('aria-expanded') === "true"
    this.dropDownMenu.setAttribute('aria-expanded', !opened)
    this.dropDownMenuOptions.setAttribute('aria-hidden', opened)
  }
}
customElements.define('customise-product-menu', CustomiseProductMenu);